import { render, staticRenderFns } from "./IconObserver.vue?vue&type=template&id=9f85271c"
import script from "./IconObserver.vue?vue&type=script&lang=js"
export * from "./IconObserver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports